import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import {ActiveQuotesClass, quoteFavorites} from "./activequotes-class.model"
import {ActiveQuoteDialogComponent} from "../../components/dialog/active-quote-dialog/active-quote-dialog.component";
// import {FormBuilder, FormGroup} from "@angular/forms";
import {ActiveQuotesService} from "../../services/active-quotes.service";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {FormControl, Validators} from "@angular/forms";
import {OktaAuthService} from "@okta/okta-angular";
// import {MatSnackBar} from "@angular/material/snack-bar";
import {UtilService} from "../../services/util.service"
import {finalize} from "rxjs/operators";
import {DataService} from "../../services/data.service";


@Component({
  selector: 'app-active-quote',
  templateUrl: './active-quote.component.html',
  styleUrls: ['./active-quote.component.scss']
})
export class ActiveQuoteComponent implements OnInit {
  // searchForm: FormGroup;
  // hideFields: boolean[];
  displayedColumns: string[] = ["opportunityName", "customerName", "utility", "startDate", "termsLabel", "brokerMargin", "facilityCount", "creditStatus", "quoteNumber", "versionDate"];
  actives: MatTableDataSource<ActiveQuotesClass>;
  pageEvent!: PageEvent;
  duplicateActives: ActiveQuotesClass[];
  isLoading: boolean = false;
  searchValue: any;
  email: string;
  brokerId: string;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() showOnlyFavorites: boolean = false;
  @Input() showSearchBar: boolean = true;
  @Input() appTitle: string = "Active Quotes";
  @Input() titleAlign: string = "left";
  dropDownSelection = new FormControl('opportunityName', [Validators.required]);
  dropDownOptions: object[] = [{label: "Opportunity Name", value: "opportunityName"}, {label: "Quote Number", value: "quoteNumber"}, {label: "Legal Entity Name", value: "legalEntityName"}, {label: "Facility Number", value: "facilityNumber"}];
  constructor( private httpService: HttpClient, public dialog: MatDialog, private quoteService: ActiveQuotesService, private oktaAuth: OktaAuthService, private utilService: UtilService, private dataService: DataService) { }


  ngOnInit(): void {
    this.isLoading = true;
    if(!this.showOnlyFavorites){
      this.displayedColumns.unshift("favorite");
    }
    this.oktaAuth.getUser().then(data => {
      this.email = data.email;
      this.brokerId = data.brokerId;
    })
    // this.httpService.get('./assets/active.json'). subscribe(
    // if(Object.keys(this.dataService.impersonateData).length || (this.utilService.userType && this.utilService.userType.toLowerCase() === 'pricing')) {
    if(localStorage.getItem("impersonation") === 'true' || (this.utilService.userType && this.utilService.userType.toLowerCase() === 'pricing')){
      this.quoteService.getActiveQuotes().subscribe(
        async (data) => {
          let actives = data as ActiveQuotesClass[];
          if (actives && actives.length) {
            actives = actives.map((item: any) => {
              item.quoteInfo = item.quoteInfo || {};
              item.opportunityName = item.quoteInfo ? item.quoteInfo.opportunityName : null
              // item.contract = "";
              item.market = item.market && item.market.trim();
              item.versionDate = new Date(item.versionDate).toLocaleString("en-US", {timeZone: "America/Chicago"});
              return item;
            })
          }
          // actives[0]['market'] = 'PJM';
          // actives[1]['market'] = "ERCOT";
          await this.quoteService.getFavoriteQuotes().toPromise().then((res: quoteFavorites[]) => {
            if (res && res.length) {
              res.forEach((favorite: quoteFavorites) => {
                for (let quote of actives) {
                  if (quote.quoteNumber === favorite.quoteNumber) {
                    quote.favorite = favorite.flag === 'Y';
                    break;
                  }
                }
              })
            }
          }).catch(err => {
            this.utilService.errorMessage(`${err.message || 'Failed to fetch favorites'}`);
          })
          if (this.showOnlyFavorites) {
            actives = actives.filter(item => item.favorite === true);
          }
          this.actives = new MatTableDataSource(actives as ActiveQuotesClass[]);
          this.actives.paginator = this.paginator;
          this.actives.sort = this.sort;
          this.isLoading = false;
          // this.actives = this.duplicateActives = actives;
          // this.hideFields = this.actives.map(item => false);
        },
        (err: HttpErrorResponse) => {
          console.log(err.message);
        }
      );
    }else{
      this.isLoading = false;
    }
    // this.searchForm = this.form.group({
    //   searchText: [''],
    //   // quoteNumber: [''],
    //   // legalEntityName: ['']facilityPostalCode
    // })
    // this.searchForm.valueChanges.subscribe(val => {
    //   this.search(val.searchText);
    // })
  }
  openDetailDialog(row){
    // if(this.showOnlyFavorites){
    //   return;
    // }
    const dialogRef = this.dialog.open(ActiveQuoteDialogComponent
      , {
        data: {
          quoteDetail: row || {}
        }
        , panelClass: 'contract-generator-dialog'
      }
    );

    const closeListener = dialogRef.componentInstance.dialogClose.subscribe(()=>{
      dialogRef.close();
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
      closeListener.unsubscribe();
    });

  }

  search(event){
    let filterValue = event && event.target ? (event.target as HTMLInputElement).value: event;
    if(event && event.target && this.dropDownSelection.value === 'facilityNumber'){
     return;
    }
    this.actives.filter = filterValue.trim().toLowerCase();
    if(this.actives.paginator){
      this.actives.paginator.firstPage();
    }
    // let searchActives: ActiveQuotesClass[] = [];
    // let actives: ActiveQuotesClass[] = this.duplicateActives;
    // searchText = searchText.toLowerCase();
    // searchActives = actives.filter(item => !searchText || (item.opportunityName && item.opportunityName.toLowerCase().indexOf(searchText) >= 0) || (typeof item.quoteNumber !== 'undefined' && item.quoteNumber.toString().toLowerCase().indexOf(searchText) >= 0) || (item.customerName && item.customerName.toLowerCase().indexOf(searchText) >= 0))
    // this.actives = searchActives;
  }

  searchFacilityNumber(){
    // let filterValue = event && event.target ? (event.target as HTMLInputElement).value: event;
    if(this.searchValue) {
      this.isLoading = true;
      this.quoteService.getQuoteByFacilityNumber(this.searchValue).subscribe(
        data => {
          let quoteNumber = data[0];
          if (quoteNumber)
            this.search(quoteNumber);
          else
            this.search('No Data$');
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.log(err.message);
          this.isLoading = false;
        }
      );
    }else{
      this.search('');
    }
  }

  getDropdownLabel(){
    let selectedVal: any = this.dropDownOptions.filter((item: any) => item.value === this.dropDownSelection.value)
    return selectedVal[0] ? "Search by " + selectedVal[0].label + "   ..." : "Search by ......"
  }

  dropDownSelectionChange(){
    this.searchValue = "";
    this.search('')
  }

  addQuoteToFavorite(row: ActiveQuotesClass){
    let requestBody = [{
      quoteNumber: row.quoteNumber,
      brokerId: this.brokerId,
      userId: this.email,
      flag: row.favorite ? 'N': 'Y'
    }];
    this.isLoading = true;
    this.quoteService.addQuoteToFavorite(requestBody)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(res => {
        this.utilService.successMessage(`Quote Number ${row.quoteNumber} added to ${row.favorite ? 'Unfavorite': 'Favorite'}`)
        row.favorite = !row.favorite;
      }, (err: HttpErrorResponse) => {
        this.utilService.errorMessage(`${err.message || 'Failed the operation'}`);
    })
  }

  // editField(e, ind){
  //   this.hideFields[ind] = !this.hideFields[ind];
  //   e.stopImmediatePropagation();
  // }

}
